import * as React from "react";
import './loading.component.scss';
import useBelfiusTheme from "../theme/ThemeHooks";

interface LoadingComponentProps
{
    show: boolean;
}

export const LoadingComponent = ( {show}: LoadingComponentProps ) => {
    let {themeClassName} = useBelfiusTheme();
    return <div className={`mi-loading-container ${themeClassName} ${show ? '' : 'd-none'}`}>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
    </div>
};